<template>
  <el-dialog :visible.sync="visible" width="1152px" append-to-body :before-close="closedDialog">
    <div slot="title">
      <div class="title-left">
        <a :title="data.title" class="title-text link-href">
          {{data.title}}
        </a>
        <span class="common-positive-negative" :class="[`is-${data.sensitivity}`]" v-if="sentiment">
          <span>{{sentiment}} {{thePercent}}</span>
        </span>
      </div>
    </div>
    <div class="info_box">
      <div>
        <span class="title-right source-text mr-8">{{data.pubdate}}</span>
        <span class="source-text">来源：{{data.site}}</span>
      </div>
      <NewsTags :data="data" />
      <div class="policy-text">
        <span v-html="formatText(data.content)"></span>
      </div>

      <el-link v-if="data.originalLink" :href="data.originalLink" class="mt-16" type="primary" target="_blank">查看原文</el-link>
    </div>
  </el-dialog>
</template>

<script>
import NewsTags from '@/views/industryChainNew/components/newsTags'
import popupMixin from '@/mixins/popup-mixin'
export default {
  name: 'DialogNewsDetail',
  components: {
    NewsTags
  },
  mixins: [popupMixin],

  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {

    }
  },
  computed: {
    sentiment() {
      const sensitivity = {
        neutral: '中性',
        positive: '正面',
        negative: '负面',
      }
      return sensitivity[this.data?.sensitivity || 'neutral']
    },
    thePercent() {
      if (this.data?.confidence !== null) {
        return this.data.confidence + '.00%'
      }
      return '--'
    }
  },
  methods: {
    formatText(text) {
      const reg = /(.*?)#&#/g
      text += '#&#'
      return text.replace(reg, (a, b) => {
        return `<p>${b}</p>`
      })
    }
  }
}
</script>

<style scoped lang="scss">
.policy-text {
  max-height: 300px;
  overflow-y: auto;
}
.title-left {
  display: flex;
  flex: 1;
  align-items: center;
}
.title-text {
  color: inherit;
  max-width: calc(100% - 250px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 14px;
  text-decoration: none;
}
</style>
